export function mapToInstallBarVisibility(
  [shouldShowInstallBar, shouldShowPwaForIOS, isAppInstalled]: [boolean, boolean, boolean | undefined],
  isIosDevice: boolean
): boolean {
  if (!shouldShowInstallBar) {
    return false;
  }

  if ((isIosDevice && !shouldShowPwaForIOS) || isAppInstalled) {
    return false;
  }

  if (!isIosDevice && isAppInstalled !== false) {
    return false;
  }

  return true;
}
